import axios from "axios";

export type GetBookingCategoriesReturn = {
    code: string,
    label: string
}[]

export const getBookingCategories =  async (req: { tenants: string[], dealers: string[] }): Promise<GetBookingCategoriesReturn> => {
    const response = await axios.get('/booking/search/categories', { params:{
        tenants: req.tenants.join(","),
        dealers: req.dealers.join(",")
    } });
    return response.data;
};